var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRedCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#FEF2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5267 23.8065C21.6988 23.8855 21.8927 23.9036 22.0764 23.8577C22.2601 23.8118 22.4228 23.7047 22.5375 23.554L22.8333 23.1665C22.9886 22.9595 23.1899 22.7915 23.4213 22.6758C23.6527 22.5601 23.9079 22.4998 24.1667 22.4998H26.6667C27.1087 22.4998 27.5326 22.6754 27.8452 22.988C28.1577 23.3006 28.3333 23.7245 28.3333 24.1665V26.6665C28.3333 27.1085 28.1577 27.5325 27.8452 27.845C27.5326 28.1576 27.1087 28.3332 26.6667 28.3332C22.6884 28.3332 18.8731 26.7528 16.0601 23.9398C13.247 21.1267 11.6667 17.3114 11.6667 13.3332C11.6667 12.8911 11.8423 12.4672 12.1548 12.1547C12.4674 11.8421 12.8913 11.6665 13.3333 11.6665H15.8333C16.2754 11.6665 16.6993 11.8421 17.0118 12.1547C17.3244 12.4672 17.5 12.8911 17.5 13.3332V15.8332C17.5 16.0919 17.4397 16.3471 17.324 16.5785C17.2083 16.81 17.0403 17.0113 16.8333 17.1665L16.4433 17.459C16.2903 17.5758 16.1825 17.742 16.1381 17.9293C16.0938 18.1166 16.1156 18.3135 16.2 18.4865C17.3389 20.7997 19.212 22.6705 21.5267 23.8065Z",
    stroke: "#E7000B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRedCall);
export default __webpack_public_path__ + "static/media/ic_red_call.3d11731b584096a38a407d024406724a.svg";
export { ForwardRef as ReactComponent };